<template>
    <div>
        <Pane title="重新申请出版" :showRemarks="false">
            <template>重新发起出版打印流程，修改出版信息</template>
        </Pane>
        <a-spin :spinning="detailLoading" style="padding:24px 160px;background: #fff;">
            <a-form
                :form="form"
                layout="horizontal"
                :colon="false"
                label-align="right"
                :label-col="{ span: 6 }"
                :wrapper-col="{ span: 14 }"
            >
                <div class="section-title">
                    基本信息
                    <a-button type="link" class="toggle-btn" @click="toggleSection('basic')">
                        <span v-html="expandedSections.basic ? '&#9660;' : '&#9650;'"></span>
                    </a-button>
                </div>
                <div class="section-content" v-show="expandedSections.basic">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="项目名称" prop="basic_projectName">
                                <a-input v-decorator="['basic_projectName']" placeholder="自动生成" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="设计编号" prop="basic_designNo">
                                <a-input v-decorator="['basic_designNo']" placeholder="自动生成" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="项目负责人" prop="basic_prjLeader">
                                <a-input v-decorator="['basic_prjLeader']" disabled/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="设计专业" prop="basic_majorName">
                                <a-input v-decorator="['basic_majorName']" disabled/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="分项名称" prop="basic_subName">
                                <a-input v-decorator="['basic_subName']" disabled/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="分项号" prop="basic_subCode">
                                <a-input v-decorator="['basic_subCode']" disabled/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="申请人" prop="basic_applicant">
                                <a-input v-decorator="['basic_applicant']" disabled/>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="申请部门" prop="basic_applyDept">
                                <a-input v-decorator="['basic_applyDept']" disabled/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>


                <div class="section-title">
                    出版信息
                    <a-button type="link" class="toggle-btn" @click="toggleSection('publish')">
                        <span v-html="expandedSections.publish ? '&#9660;' : '&#9650;'"></span>
                    </a-button>
                </div>
                <div class="section-content" v-show="expandedSections.publish">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="打印类型" prop="printType">
                                <a-radio-group v-decorator="['printType', { initialValue: 'normal' }]">
                                    <a-radio-button v-for="item in printTypeList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="是否鲜章" prop="isFreshStamp">
                                <a-radio-group v-decorator="['isFreshStamp', { initialValue: false }]">
                                    <a-radio-button :value="false">否</a-radio-button>
                                    <a-radio-button :value="true">是</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :lg="24" :md="24" :sm="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }" label="出版要求" prop="publishRequirement">
                                <a-textarea v-decorator="['publishRequirement']" :rows="2" placeholder="请输入出版要求" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="纸张要求" prop="paperRequirement">
                                <a-select v-decorator="['paperRequirement']" placeholder="请选择纸张要求" allow-clear>
                                    <a-select-option v-for="item in paperList" :key="item.value" :value="item.value">{{ item.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="装订要求" prop="bindingRequirement">
                                <a-radio-group v-decorator="['bindingRequirement']">
                                    <a-radio-button v-for="item in bindingList" :key="item.value" :value="item.value">{{ item.name }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="取图人" prop="pictographerName">
                                <a-input v-decorator="['pictographerName']" placeholder="请输入取图人姓名" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="取图人手机号" prop="pictographerMobile">
                                <a-input v-decorator="['pictographerMobile']" placeholder="请输入取图人手机号" />
                            </a-form-item>
                        </a-col>
                        <a-col :lg="24" :md="24" :sm="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }" label="备注" prop="publishRemark">
                                <a-textarea v-decorator="['publishRemark']" :rows="3" placeholder="请输入备注" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </div>

                <div class="section-title">
                    图纸清单
                    <a-button type="link" class="toggle-btn" @click="toggleSection('drawing')">
                        <span v-html="expandedSections.drawing ? '&#9660;' : '&#9650;'"></span>
                    </a-button>
                </div>
                <div class="section-content" v-show="expandedSections.drawing">
                    <a-table
                        :columns="subColumns"
                        :data-source="detail?.subList || []"
                        row-key="id"
                        :pagination="false"
                        bordered
                        :row-selection="{ selectedRowKeys: subSelectedRowKeys, onChange: onSubSelectChange }"
                    >
                        <template slot="fileLink" slot-scope="text, record">
                            <a href="javascript:void(0)" @click="handleOpenFile(record.attachment)">{{ text }}</a>
                        </template>
                    </a-table>
                </div>
                <div class="center">
                    <a-space>
                        <a-button type="primary" @click="submitReview" :loading="submitting">
                            重新提交
                        </a-button>
                        <a-button @click="goBack">返回</a-button>
                    </a-space>
                </div>
            </a-form>
        </a-spin>
    </div>
</template>

<script>
import { queryFileById } from '@/api/project-execute/result';
import { fetchPublishPrintDetail, resubmitPublishPrint } from "@/api/approval/publish";
import { mapActions } from 'vuex';
export default {
    name: 'PublishApply',
    data() {
        return {
            visible: false,
            form: this.$form.createForm(this),
            loading: false,
            detailLoading: false,
            submitting: false,
            detail: null,
            personData: {},
            filterByMajor1: false,
            filterByMajor2: false,
            expandedSections: { basic: true, drawing: true, publish: true, stamp: true, person: true },
            subSelectedRowKeys: [],
            subColumns: [
                { title: '流水号', dataIndex: 'serialNo', key: 'serialNo', width: 120 },
                { title: '版本号', dataIndex: 'versionNo', key: 'versionNo', width: 50 },
                { title: '图名', dataIndex: 'name', key: 'name', width: 200 },
                { title: '分图号', dataIndex: 'subDrawingNo', key: 'subDrawingNo', width: 150 },
                { title: '页码', dataIndex: 'pageNumber', key: 'pageNumber', width: 50 },
                { title: '总页数', dataIndex: 'pageCount', key: 'pageCount', width: 50 },
                { title: '纸张尺寸', dataIndex: 'pageSize', key: 'pageSize', width: 50 },
                { title: '制图人', dataIndex: 'drawerName', key: 'drawerName', width: 80 },
                { title: '附件', dataIndex: 'name', key: 'fileLink', width: 80, scopedSlots: { customRender: 'fileLink' } },
            ],
            disabledPersonValues: [
                'cosys_stamp_fadingdaibiaoren',
                'cosys_stamp_pizhun',
                'cosys_stamp_jishufuze',
                'cosys_stamp_jishufuze2',
                'cosys_stamp_shejifuze2',
                'cosys_stamp_sheji',
                'cosys_stamp_zhitu',
            ],
        };
    },
    computed: {
        printTypeList() {
            const findDataDict = this.$store.getters['setting/findDataDict'];
            return (findDataDict && findDataDict('cosys.printType')) || [];
        },
        paperList() {
            const findDataDict = this.$store.getters['setting/findDataDict'];
            return (findDataDict && findDataDict('cosys.Paper')) || [];
        },
        bindingList() {
            const findDataDict = this.$store.getters['setting/findDataDict'];
            return (findDataDict && findDataDict('cosys.Binding')) || [];
        },
    },
    created() {
        this.loadData();
    },
    methods: {
        toggleSection(key) {
            this.$set(this.expandedSections, key, !this.expandedSections[key]);
        },
        onSubSelectChange(selectedRowKeys) {
            this.subSelectedRowKeys = selectedRowKeys;
        },
        async loadData() {
            const id = this.$route.params.id;
            if (!id) return;
            this.detailLoading = true;
            try {
                const res = await fetchPublishPrintDetail(id);
                this.detail = res;
                this.subSelectedRowKeys = (res?.subList || []).map(item => item.id);
                this.$nextTick(() => {
                    this.form.setFieldsValue(this.buildFormValues(res));
                });
            } finally {
                this.detailLoading = false;
            }
        },
        buildFormValues(d) {
            if (!d) return {};
            console.log("d:::",d)
            return {
                basic_projectName: d.designStamp?.personnel?.projectName || '',
                basic_designNo: d.designStamp?.phase?.designCode || '',
                basic_prjLeader: d.designStamp?.phase?.planPrjLeaderName || '',
                basic_majorName: d.designStamp?.phase?.phaseName || '',
                basic_subName: d.subName || '',
                basic_subCode: d.subCode || '',
                basic_applicant: d.publishApplyUserName || '',
                basic_applyDept: d.designStamp?.phase?.cooperateDeptNames || '',
                stampDesignId1: d.stampDesignId1 || undefined,
                stampDesignId2: d.stampDesignId2 || undefined,
                stampRegisterId1: d.stampRegisterId1 || undefined,
                stampRegisterId2: d.stampRegisterId2 || undefined,
                drawingDate: d.drawingDate || undefined,
                publishRequirement: d.publishRequirement || '',
                paperRequirement: d.paperRequirement || undefined,
                bindingRequirement: d.bindingRequirement || undefined,
                pictographerName: d.pictographerName || '',
                pictographerMobile: d.pictographerMobile || '',
                publishRemark: d.publishRemark || '',
                printType: d.printType || 'normal',
                isFreshStamp: d.isFreshStamp ?? false,
                ...this.buildPersonValues(d),
            };
        },
        buildPersonValues() {
            return {};
        },
        populatePersonData() {},
        getDictName(dictList, value) {
            if (!value) return '';
            const item = dictList.find(i => i.value === value);
            return item ? item.name : value;
        },
        handlePersonChange(field, arr) {
            this.$set(this.personData, field, arr[0] || {});
        },
        handleOk() {},
        goBack() {
            this.$router.go(-1);
        },
        handleCancel() {
            this.form.resetFields();
            this.personData = {};
            this.detail = null;
            this.subSelectedRowKeys = [];
            this.$emit('setVisible', false);
        },
        handleOpenFile(attachmentId) {
            if (!attachmentId) return;
            queryFileById(attachmentId).then(res => {
                if (res?.completePath) {
                    const url = res.completePath;
                    const filename = this.getFileNameFromUrl(url);
                    if (this.isPdfFile(filename)) {
                        this.previewPdf(url, filename);
                    } else {
                        window.open(url);
                    }
                }
            });
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        getFileNameFromUrl(url) {
            const str = String(url || '');
            if (!str) return '';
            const urlWithoutParams = str.split('?')[0];
            let fileName = urlWithoutParams.split('/').pop();
            const idx = fileName.indexOf('_');
            if (idx !== -1) fileName = fileName.substring(idx + 1);
            return decodeURIComponent(fileName);
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        submitReview() {
            this.form.validateFields((err, formValues) => {
                if (err) return;
                this.submitting = true;
                resubmitPublishPrint({
                    id: this.detail?.id,
                    designStampId: this.detail?.designStampId,
                    originalPublishId: this.detail?.originalPublishId,
                    bindingRequirement: formValues.bindingRequirement,
                    paperRequirement: formValues.paperRequirement,
                    publishRequirement: formValues.publishRequirement,
                    printType: formValues.printType,
                    isFreshStamp: formValues.isFreshStamp,
                    pictographerName: formValues.pictographerName,
                    pictographerMobile: formValues.pictographerMobile,
                    publishRemark: formValues.publishRemark,
                    stampSubIds: this.subSelectedRowKeys.join(','),
                })
                    .then(() => {
                        this.$close(this.$route.path, "/approval/task");
                    })
                    .catch((e) => {
                        console.error("提交失败详情", e);
                        this.$message.error("提交失败");
                    })
                    .finally(() => {
                        this.submitting = false;
                    });
            });
        },
    },
};
</script>

<style lang="less" scoped>
.section-title {
    font-weight: bold;
    font-size: 15px;
    margin: 16px 0 8px 0;
    padding-bottom: 6px;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.toggle-btn {
    padding: 0 4px;
    height: auto;
    font-size: 14px;
}
.sub-title {
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 8px;
}
.section-content {
    background: #fafafa;
    padding: 12px;
    border-radius: 4px;
}
.center{
    margin: 20px 0;
}
</style>
